import axios from 'axios'
import { shallowRef } from 'vue'

/**
 * RED-317 §8 — one overview in the drawer: its versions and the Studio
 * projection of the version on screen (the current one unless another is
 * picked). Every open starts from the server; nothing is cached here, so a
 * version published elsewhere shows on the next open.
 *
 * A response that arrives after the drawer moved on (another cell, another
 * version) is dropped, so a slow answer never paints the wrong text.
 */
export function useMarketOverviewDocument() {
  const versions = shallowRef([])
  const document = shallowRef(null)
  const loading = shallowRef(false)
  const failed = shallowRef(false)

  let ticket = 0

  const reset = () => {
    ticket++
    versions.value = []
    document.value = null
    loading.value = false
    failed.value = false
  }

  /**
   * @param {number} overviewId
   * @param {number|null} versionNumber null = the current version
   */
  const open = async (overviewId, versionNumber = null) => {
    const mine = ++ticket
    loading.value = true
    failed.value = false
    try {
      const params = versionNumber === null ? {} : { version: versionNumber }
      const [versionsResponse, documentResponse] = await Promise.all([
        axios.get(route('admin.market-overview.versions', overviewId)),
        axios.get(route('admin.market-overview.document', overviewId), { params }),
      ])
      if (mine !== ticket) {
        return
      }
      versions.value = versionsResponse.data.versions ?? []
      document.value = documentResponse.data
    } catch {
      if (mine === ticket) {
        document.value = null
        failed.value = true
      }
    } finally {
      if (mine === ticket) {
        loading.value = false
      }
    }
  }

  return { versions, document, loading, failed, open, reset }
}
